import * as angular from 'angular';

"use strict";
angular.module('MainCtrl', ['AuthService']);

export default 'MainCtrl';
